"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSK = function FlagSK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-88.82,78.81C-90.91,77.61-140,49-140,5.12v-60H-34.1v60c0,43.92-49.13,72.49-51.22,73.69l-1.75,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.32-5.48-76-3.28h-5.55v-9.94h3.33L-64.88-11l-1.8-7.75,1.8-7.74-13.31,2.19h-3.33v-3.35l2.19-16.65-7.74,2.26-7.74-2.26,2.19,16.65v3.35h-3.33l-13.32-2.19,1.81,7.74L-109.27-11l13.32-2.2h3.33v9.94h-5.55l-16.64-2.2,2.25,7.74L-114.81,10l16.64-2.2h5.55V33.37h11.1V7.81H-76L-59.32,10l-2.26-7.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-87.07,22.77a17.66,17.66,0,0,0-16.24,10.74c-.48,0-.93-.14-1.41-.14A17.6,17.6,0,0,0-122.28,50,133.83,133.83,0,0,0-88.82,78.81l1.75,1,1.75-1A133.83,133.83,0,0,0-51.86,50,17.6,17.6,0,0,0-69.41,33.37c-.49,0-.94.1-1.42.14A17.65,17.65,0,0,0-87.07,22.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.63-51.38V5.12c0,42.37-49.44,70.62-49.44,70.62S-136.5,47.49-136.5,5.12v-56.5h98.87m7.06-7.06h-113V5.12c0,45.94,50.84,75.51,53,76.75l3.5,2,3.5-2c2.17-1.24,53-30.81,53-76.75V-58.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSK;
exports["default"] = _default;